import script from "./MonthlyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyDetail.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyDetail.vue?vue&type=style&index=0&id=6d87dbe5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d87dbe5"]])

export default __exports__